import {CountryCode} from './country-code.interface';
export class CountryLocale {
  [lang: string]: CountryCode
}
